import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// a double-clicked Save must not create the same record twice
const inflight = new Set();

api.interceptors.request.use((cfg) => {
  // every request declares the academic session it is working in
  const session = localStorage.getItem("bf_session") || "";
  if (session) cfg.headers["X-Session"] = session;
  const method = (cfg.method || "get").toLowerCase();
  if (method === "get") return cfg;
  const key = `${method}:${cfg.url}:${typeof cfg.data === "string" ? cfg.data : JSON.stringify(cfg.data || "")}`;
  if (inflight.has(key)) {
    const err = new Error("duplicate");
    err.duplicate = true;
    return Promise.reject(err);
  }
  inflight.add(key);
  cfg.dedupeKey = key;
  return cfg;
});

api.interceptors.response.use(
  (res) => {
    inflight.delete(res.config?.dedupeKey);
    return res;
  },
  (err) => {
    inflight.delete(err.config?.dedupeKey);
    return Promise.reject(err);
  });

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  if (e?.duplicate) return "Already saving — give it a second";
  return apiError(e?.response?.data?.detail) || e?.message || "Request failed";
}

export default api;
